export default class extends Controller {

  connect() {
    this.refreshContent = this.refreshContent.bind(this)
    this.replaceContentWith = this.replaceContentWith.bind(this)
    App.Helpers.listenToCustomEvent(document, "update-success", this.refreshContent)
    App.Helpers.listenToCustomEvent(document, "priority:updated", this.refreshContent)
    App.Helpers.listenToCustomEvent(document, "task-unblock:success", this.refreshContent);
    App.Helpers.listenToCustomEvent(document, "task-block:success", this.refreshContent);
  }

  refreshContent(event) {
    App.Helpers.ajaxRequest({ url: this.refreshURL, successHandler: this.replaceContentWith })
  }

  replaceContentWith(content) {
    App.Helpers.replaceElement(this.element, content)
  }

  get refreshURL() {
    return this.data.get("refresh-url")
  }
}



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/tasks/task-details-slide-out-controller.js